import React, { createContext, useState, useContext, useEffect, useCallback } from 'react';
import { safeLocalStorage } from '../utils/storage';

const LanguageContext = createContext();

const translations = {
    es: {
        // General
        submit: "ENVIAR SEÑAL",
        cancel: "ABORTAR",
        home: "INICIO",
        loading: "PROCESANDO...",
        back: "VOLVER",
        // SeccionUsuarios
        loginTitle: "IDENTIFICACIÓN DE AGENTE",
        registerTitle: "ALTA EN EL SISTEMA",
        loginSubtitle: "Introduzca sus credenciales de acceso",
        registerSubtitle: "Únete a la red de investigación",
        namePlaceholder: "TU NOMBRE O ALIAS",
        cityPlaceholder: "CIUDAD (OPCIONAL)",
        emailPlaceholder: "CORREO ELECTRÓNICO",
        passwordPlaceholder: "CONTRASEÑA",
        noAccount: "¿No tienes credenciales todavía? ",
        hasAccount: "¿Ya eres agente oficial? ",
        registerLink: "Regístrate aquí",
        loginLink: "Inicia sesión",
        // Carta Astral
        astralTitle: "CARTA ASTRAL DEL AGENTE",
        astralSubtitle: "Descifrando las coordenadas de tu destino",
        birthDate: "Fecha de Nacimiento",
        birthTime: "Hora (Si la sabes)",
        birthCity: "Ciudad de Origen",
        cityExample: "Ej: Granada, España",
        tuneButton: "SINTONIZAR CARTA",
        // Tarot
        tarotTitle: "EL ORÁCULO DEL BÚNKER",
        tarotSubtitle: "Selecciona 5 Arcanos para descifrar tu frecuencia",
        tarotCardsChosen: "Cartas elegidas",
        tarotReveal: "REVELAR DESTINO",
        tarotNewRitual: "NUEVO RITUAL",
        tarotMessage: "📜 MENSAJE DEL ORÁCULO",
        tarotSyncing: "SINTONIZANDO...",
        // Horoscopo
        horoscopoTitle: "HORÓSCOPO DEL BÚNKER",
        horoscopoSubtitle: "Las estrellas revelan lo que las sombras ocultan",
        horoscopoLoading: "Sintonizando frecuencias estelares...",
        horoscopoSyncDate: "Fecha de sincronización",
        horoscopoWarning: "Advertencia: Las predicciones son generadas por la frecuencia de la IA. El destino está en tus manos.",
        horoscopoBack: "VOLVER AL BÚNKER",
        // Navbar
        navHome: "INICIO",
        navGallery: "GALERÍA",
        navVideos: "VÍDEOS",
        navNews: "NOTICIAS",
        navAudios: "AUDIOS",
        navMysteries: "MISTERIOS HISTÓRICOS",
        navFiles: "EXPEDIENTES",
        navMap: "MAPA",
        navHoroscope: "HORÓSCOPO",
        navTarot: "TAROT",
        navAstral: "ASTRAL",
        navChat: "CHAT",
        // Home (Indice)
        systemActive: "SISTEMA DE VIGILANCIA ACTIVO - SECTOR GRANADA/GLOBAL",
        systemStatusLabel: "ESTADO DEL SISTEMA:",
        systemStatusValue: "OPERATIVO / VIGILANCIA ACTIVA",
        sectorLabel: "SECTOR:",
        sectorValue: "GRANADA - GLOBAL",
        accessLevelLabel: "NIVEL DE ACCESO:",
        accessLevelAgent: "AGENTE AUTORIZADO",
        accessLevelVisitor: "VISITANTE NO IDENTIFICADO",
        recentIntel: "INTELIGENCIA RECIENTE:",
        tickerText: "🛰️ SATÉLITE EN LÍNEA: RASTREANDO SEÑALES EN EL SECTOR GRANADA... 🛸 ACTIVIDAD ANÓMALA DETECTADA EN ATARFE... 📡 ARCHIVO CENTRAL ACTUALIZADO... 🎖️ NUEVOS RANGOS DISPONIBLES PARA AGENTES ACTIVOS...",
        visualCalibration: "CALIBRACIÓN VISUAL:",
        navPrivacy: "POLÍTICA DE PRIVACIDAD",
        navCookies: "POLÍTICA DE COOKIES",
        navLegal: "AVISO LEGAL",
        navAboutProject: "SOBRE EL PROYECTO",
        dossierTitle: "JOSE MORENO JIMÉNEZ - INVESTIGADOR AL MANDO",
        dossierDesc1: "Detrás de este búnker se encuentra una historia real. Mi curiosidad por lo inexplicable se disparó tras grabar personalmente unos objetos anómalos en Atarfe (Granada), un suceso que cambió mi forma de ver el cielo y que fue el motor para fundar esta plataforma.",
        dossierDesc2: "EXPEDIENTEXGRANAINO nació de la necesidad de centralizar evidencias y testimonios de todo el mundo para compararlos y buscar respuestas. Aquí no buscamos imponer verdades, sino compartir preguntas y proteger la historia oculta de nuestro planeta.",
        dossierViewAtarfe: "📹 VER GRABACIÓN DE ATARFE",
        dossierFullProtocols: "CONSULTAR PROTOCOLOS COMPLETOS",
        rankSystemTitle: "SISTEMA DE RANGOS Y MERECIMIENTOS",
        rankSystemDesc: "Cada reporte enviado y cada interacción en el búnker te otorga puntos de experiencia para ascender en la escala de mando del sector.",
        rankLevels: "🔰 Prácticas ➔ 🎖️ Cabo (3) ➔ 🎖️🎖️ Cabo 1º (10) ➔ ⭐ Sargento (20) ➔ ⭐⭐ Teniente (50) ➔ ⭐⭐⭐ Capitán (100)",
        accessWorldRadar: "ACCEDER AL RADAR MUNDIAL (MAPA)",
        reportExperience: "REPORTAR EXPERIENCIA / SUCESO",
        freeAgentRegister: "REGISTRO GRATUITO DE AGENTE",
        contributeMedia: "APORTAR EVIDENCIA MULTIMEDIA",
        dossierOpen: "[+] DESCLASIFICAR ORIGEN DEL BÚNKER (SOBRE MÍ)",
        dossierClose: "[-] CERRAR ARCHIVO PERSONAL",
        dossierBtnAtarfe: "📹 VER GRABACIÓN DE ATARFE",
        dossierBtnProtocols: "CONSULTAR PROTOCOLOS COMPLETOS",
        // Bilingual Slide
        slideBilingualTitle: "VERSIÓN BILINGÜE ACTIVA",
        slideBilingualSubtitle: "CONEXIÓN INTERNACIONAL",
        slideBilingualTagline: "ESP/ENG FULL SUPPORT",
        slideBilingualInfoTitle: "BÚNKER MULTILENGUAJE",
        slideBilingualInfoText: "Hemos desclasificado nuestra interfaz para agentes internacionales. Ahora puedes navegar por todo el búnker en Español e Inglés.",
        slideBilingualHighlight: "¡CONECTA CON LA RED GLOBAL!",
        slideBilingualBtn: "CAMBIAR IDIOMA",
        // Efemerides
        efemeridesTitle: "HOY EN LA HISTORIA X",
        efemeridesLoading: "Desclasificando archivos históricos...",
        efemeridesExpand: "[+] DESCLASIFICAR INFORME COMPLETO",
        efemeridesCollapse: "[-] CLASIFICAR ARCHIVO",
        efemeridesFooter: "ARCHIVO DESCLASIFICADO — EXPEDIENTEXGRANAINO",
        // About Us
        aboutTitle: "📂 DOSSIER DEL PROYECTO",
        aboutWhatIs: "¿QUÉ ES EXPEDIENTEX GRANAINO?",
        aboutWhatIsDesc1: "Expediente X Granaíno es un proyecto digital independiente creado en 2026 en Atarfe (Granada) por José Moreno Jiménez. Nació con una meta clara: actuar como un índice documental y repositorio de síntesis de sucesos reales, fenómenos anómalos, crónica negra y enigmas históricos de España y de todo el mundo.",
        aboutWhatIsDesc2: "Este archivo no pretende ser una enciclopedia inabarcable de tratados interminables de 20.000 palabras, sino una guía accesible, directa y rigurosa. Cada expediente está concebido como una ficha de síntesis pensada para despertar la curiosidad del lector, presentar las evidencias documentadas y actuar como punto de partida para incitar a investigar y profundizar a través de fuentes contrastadas y bibliografía especializada.",
        aboutOrigin: "EL ORIGEN DEL BÚNKER",
        aboutOriginDesc1: "Detrás del desarrollo y mantenimiento de esta web no hay ningún gran equipo editorial ni ninguna corporación: soy José Moreno Jiménez, programador y apasionado del misterio desde Atarfe. Mi interés por estos temas se multiplicó tras presenciar y filmar personalmente unos fenómenos aéreos no identificados a los que no encontré explicación convencional (puedes ver la grabación original en la sección de vídeos).",
        aboutOriginDesc2: "Esa experiencia personal fue el detonante que me impulsó en 2026 a programar este portal. Lejos de inventar historias o imponer verdades absolutas, este búnker busca ordenar casos reales que a menudo quedan sepultados en hemerotecas, compartir preguntas legítimas y facilitar libros y fuentes para que cada lector saque sus propias conclusiones.",
        aboutMethodology: "METODOLOGÍA Y FILOSOFÍA DE ARCHIVO",
        aboutMethodologyDesc1: "La metodología de este portal se fundamenta en la síntesis informativa de fuentes públicas, documentos desclasificados, artículos de prensa histórica y testimonios directos. Mi labor consiste en filtrar, recopilar y resumir los puntos cardinales de cada suceso para que el lector disponga de una panorámica clara en pocos minutos de lectura.",
        aboutMethodologyDesc2: "Al final de los expedientes donde existen obras de referencia publicadas por historiadores, periodistas o testigos, incorporamos una sección bibliográfica recomendada. De este modo, quien desee pasar de la curiosidad a la investigación profunda tiene a su alcance los libros y ensayos clave del caso.",
        aboutMission: "PROPÓSITO",
        aboutMissionDesc: "Ofrecer un índice claro y directo de casos reales para despertar la curiosidad crítica.",
        aboutVision: "FILOSOFÍA",
        aboutVisionDesc: "Transparencia, investigación independiente y rigor en las fuentes documentales.",
        aboutValues: "VALORES",
        aboutValuesDesc: "Honestidad, rigor histórico y pasión por el misterio real.",
        aboutContact: "¿CONOCES UN CASO REAL O TIENES INFORMACIÓN? CONTACTA O SÍGUEME EN REDES:",
        // Expedientes
        expTitle: "EXPEDIENTES Y CASOS CLASIFICADOS",
        expProtocol: "🛡️ PROTOCOLO DE VERACIDAD: Priorizamos informes basados en sucesos reales, testimonios directos y evidencias de campo. Aunque permitimos la reconstrucción narrativa, la fidelidad a los hechos es nuestro estandarte. Documenta con responsabilidad.",
        expAgentReports: "INFORMES DE AGENTES",
        expAdminStories: "RELATOS DEL ADMINISTRADOR",
        expStatus: "ESTADO",
        expImage: "IMAGEN",
        expLocation: "UBICACIÓN",
        expAction: "ACCIÓN",
        expOpen: "ABRIR",
        expRadarSearch: "RADAR GEOGRÁFICO (BUSCAR CIUDAD/PUEBLO):",
        expWriteReport: "REDACTAR NUEVO INFORME",
        expWriteAdmin: "REDACTAR RELATO OFICIAL",
        expPublish: "PUBLICAR RELATO",
        expUpload: "SUBIR AL ARCHIVO",
        expDecrypt: "DESCRIPTANDO SEÑAL...",
        expNoData: "📡 FRECUENCIA LIMPIA. NINGUNA ACTIVIDAD DETECTADA.",
        expSearchPlaceholder: "Buscar por título, contenido o alias de agente...",
        expFilterAll: "📁 VER TODO",
        expFilterAdmin: "🛡️ ALTO MANDO",
        expFilterAgent: "👤 AGENTES DE CAMPO",
        // App / System
        sysLogoutConfirm: "¿FINALIZAR TURNO DE GUARDIA, AGENTE?",
        sysLogoutBtn: "DESCONECTAR AGENTE",
        sysAccessBunker: "🔑 ACCESO AL BÚNKER",
        sysAgentLabel: "👤 AGENTE:",
        sysControlPanel: "⚡ PANEL DE MANDO",
        sysVisualFreq: "FRECUENCIA VISUAL",
        sysSidebarDossier: "⚠️ Dossier Atarfe",
        sysSidebarDossierDesc: "Dossier Atarfe",
        // Galeria
        galleryTitle: "GALERÍA DE EVIDENCIAS",
        galleryAccessLevel: "NIVEL DE ACCESO:",
        galleryWriteStory: "REDACTAR RELATO",
        galleryTabNews: "NOTICIAS",
        galleryTabStories: "RELATOS",
        galleryTabMisterios: "MISTERIOS",
        galleryTabTrueCrime: "TRUE CRIME",
        galleryNoData: "📡 ESCANEANDO SECTOR... NO SE DETECTAN REGISTROS.",
        galleryScanning: "ESCANEANDO SECTOR...",
        galleryViewFullStory: "📖 LEER RELATO COMPLETO",
        galleryViewFullNews: "📰 VER NOTICIA COMPLETA",
        galleryViewFullMisterio: "👽 VER MISTERIO COMPLETO",
        galleryViewFullCaso: "💀 VER CASO COMPLETO",
        galleryRadarLocalize: "📍 LOCALIZAR EN EL RADAR",
        galleryLinkedFile: "🔒 ARCHIVO VINCULADO: Esta evidencia gráfica forma parte de una crónica detallada en el archivo central. Pulsa el botón superior para desclasificar el relato completo.",
        galleryNoNotes: "Sin notas adicionales en el informe.",
        badgeNews: "📰 NOTICIA",
        badgeMystery: "👽 MISTERIO HISTÓRICO",
        badgeTrueCrime: "🛡️ CASO REAL / TRUE CRIME",
        badgeAgentExp: "👤 EXPEDIENTE AGENTE",
        // Chat
        chatFrequency: "FRECUENCIA:",
        chatOnline: "(EN LÍNEA)",
        chatOffline: "(DESCONECTADO)",
        chatReset: "REINICIAR",
        chatSearching: "📡 Buscando señales en la frecuencia...",
        chatWriteOrder: "Escribir orden...",
        chatWriteMessage: "Escribir mensaje...",
        chatEmit: "EMITIR",
        chatTransmit: "TRANSMITIR",
        // Astral Chart Months
        month1: "Enero",
        month2: "Febrero",
        month3: "Marzo",
        month4: "Abril",
        month5: "Mayo",
        month6: "Junio",
        month7: "Julio",
        month8: "Agosto",
        month9: "Septiembre",
        month10: "Octubre",
        month11: "Noviembre",
        month12: "Diciembre",
        day: "Día",
        month: "Mes",
        year: "Año",
        // Evidence & Reporting
        reportEvidence: "REGISTRAR NUEVA PRUEBA",
        findingTitle: "TÍTULO DEL HALLAZGO",
        findingPlaceholder: "Ej: Psicofonía en sótano...",
        imageUrlOptional: "URL DE IMAGEN (OPCIONAL)",
        latLong: "LATITUD / LONGITUD",
        scanGps: "🛰️ SCAN SECTOR (GPS)",
        uploadMethod: "MÉTODO DE SUBIDA",
        uploadFile: "SUBIR ARCHIVO (.MP3)",
        uploadLink: "ENLACE / IFRAME (iVoox, Spotify)",
        fileMp3: "ARCHIVO (.MP3)",
        externalLink: "CÓDIGO DE INSERCIÓN O ENLACE",
        externalLinkPlaceholder: "Pega aquí el código <iframe...> o enlace externo",
        // News
        newsTitle: "TITULAR DEL SUCESO",
        newsLocation: "📍 UBICACIÓN (BUSCADOR GPS):",
        newsLocationPlaceholder: "Ej: NASA, Area 51, Granada...",
        newsSearch: "BUSCAR",
        newsSource: "🌐 ENLACE A FUENTE (OPCIONAL):",
        newsVisual: "📷 ADJUNTAR EVIDENCIA VISUAL:",
        newsLevel: "NIVEL DE ALERTA:",
        newsLevelLow: "Bajo",
        newsLevelMed: "Medio",
        newsLevelHigh: "Alto",
        newsLevelCrit: "CRÍTICO",
        newsDesc: "DESCRIBA LOS DETALLES DEL AVISTAMIENTO O SUCESO...",
        // Videos
        videoRegister: "NOMBRE DEL REGISTRO:",
        videoRegisterPlaceholder: "Ej: Avistamiento en el Genil",
        videoUrl: "URL O NOMBRE DE ARCHIVO:",
        videoUrlPlaceholder: "URL de YouTube o nombre del archivo local",
        videoCaptures: "URLS DE CAPTURAS (Separadas por comas):",
        videoCapturesPlaceholder: "https://imagen1.jpg, https://imagen2.jpg...",
        videoGps: "🛰️ ACTIVAR RADAR GPS (LOCALIZACIÓN ACTUAL)",
        // Messages
        accessDenied: "⚠️ ACCESO RESTRINGIDO",
        loginRequired: "Debes estar identificado en el búnker para acceder a tu frecuencia astral.",
        errorFallen: "Fallo en el servidor del búnker.",
        successAuth: "✅ ACCESO CONFIRMADO",
        successReg: "✅ ¡LISTO! Te has unido a la red del Búnker.",
        anonymousInfo: "🔒 100% ANÓNIMO: Solo necesitamos tu Alias y Contraseña.",
        optionalEmail: "Solo si quieres recuperar la contraseña luego...",
        yourSector: "Tu sector...",
        // Mapa (Lugares)
        mapExpand: "AMPLIAR EN SECCIÓN",
        mapLoading: "ESCANEANDO SECTOR...",
        mapError: "ERROR DE CARGA",
        mapDossier: "📜 RELATO",
        mapNews: "📰 NOTICIA",
        mapPlace: "📍 LUGAR",
        mapEvidence: "📸 EVIDENCIA",
        mapAuthor: "AUTOR",
        mapAgent: "AGENTE",
        mapSystem: "SISTEMA",
        mapNoDesc: "Sin descripción adicional en el archivo.",
        mapObjectives: "OBJETIVOS",
        mapSystemLabel: "SISTEMA",
        mapActive: "ACTIVO",
        // Videos & Audios Alerts
        videoNoGps: "El búnker no detecta tu señal GPS.",
        videoGpsError: "❌ FALLO AL ESCANEAR SECTOR: ",
        videoIdentify: "Identifícate como agente.",
        videoSent: "✅ VÍDEO ENVIADO: La central revisará el material antes de publicarlo.",
        audioNoGps: "GPS NO DETECTADO.",
        audioNoFile: "Selecciona un archivo primero, hermano.",
        audioNoLink: "Pega un enlace o código iframe.",
        audioSent: "✅ Psicofonía enviada. El Alto Mando debe revisarla.",
        audioError: "❌ Fallo en la transmisión. Verifique su identidad de agente.",
        audioExternal: "🎧 ABRIR ARCHIVO EXTERNO",
        audioNoData: "📡 No hay registros aprobados o la base de datos está fuera de línea...",
        audioCompatible: "SISTEMA NO COMPATIBLE",
        // Hero Slides
        heroReport: "Informar Avistamiento",
        heroGalleryTitle: "MULTIMEDIA Y EVIDENCIAS",
        heroGalleryDesc: "Explora nuestra galería de fotos y vídeos analizados por el mando central. Evidencias de lo inexplicable en alta resolución.",
        heroGalleryBtn: "Explorar Galería",
        heroStoriesTitle: "RELATOS Y MISTERIOS",
        heroStoriesDesc: "Sumérgete en los relatos más impactantes y misterios históricos que desafían la lógica. La verdad está escrita en estas páginas.",
        heroStoriesBtn: "Leer Relatos",
        heroRankTitle: "SISTEMA DE RANGOS AGENTE",
        heroRankDesc: "Tu lealtad y actividad son monitorizadas. Sube de rango automáticamente: Agente > Cabo > Sargento > Teniente > Capitán. ¡Alcanza el estatus de élite!",
        heroRankBtn: "Ver Mi Perfil",
        heroRegisterTitle: "REGISTRO 100% ANÓNIMO",
        heroRegisterDesc: "Hemos actualizado nuestros protocolos de seguridad. Ahora puedes darte de alta en el Búnker de ExpedienteXGranaino usando solo un Alias. Cero datos personales.",
        heroRegisterBtn: "Registrarse Ahora",
        heroNewFile: "NUEVO ARCHIVO",
        heroLatestNews: "ÚLTIMA NOTICIA",
        heroLatestExp: "ÚLTIMA HORA",
        heroNewsBtn: "Leer Noticia",
        heroExpBtn: "Abrir Informe",
        heroNavReport: "REPORTAR EXPERIENCIA",
        heroNavReg: "REGISTRO GRATUITO",
        heroNavMedia: "APORTAR MULTIMEDIA",
        heroNavAccess: "ACCESO AGENTES",
        heroObserverNetwork: "OBSERVER NETWORK",
        heroObserverTitle: "LA RED DE OBSERVADORES DE EXPEDIENTEXGRANAINO",
        heroObserverText: "Forma parte del próximo gran acontecimiento. Una red exclusiva para entusiastas de los OVNIS y la ufología técnica.",
        heroObserverHighlight: "¡SOLO PARA MIEMBROS DEL BÚNKER!",
        // Noticias
        newsSystemScanning: "SINTONIZANDO ARCHIVO DE NOTICIAS...",
        newsGlobalAlerts: "NOTICIAS Y CRÓNICAS DE ACTUALIDAD",
        newsNoImage: "ARCHIVO SIN IMAGEN",
        newsNoAlerts: "SIN ALERTAS LOCALES ACTIVAS. RASTREANDO FRECUENCIAS SECUNDARIAS...",
        newsExternalIntel: "🌐 INTELIGENCIA EXTERNA (CANALES RECOMENDADOS)",
        newsAccess: "ACCEDER",
        newsPrev: "ATRÁS",
        newsNext: "SIGUIENTE",
        newsReportSent: "📡 REPORTE ENVIADO AL BÚNKER. ESPERE VALIDACIÓN DEL ALTO MANDO.",
        newsError: "❌ Transmisión interrumpida. Compruebe su conexión.",
        // Expedientes Addons
        expShareText: "🛸 ¡AVISTAMIENTO DETECTADO! Mira este expediente en el Búnker de ExpedienteX: ",
        expCopySuccess: "📎 ENLACE COPIADO AL PORTAPAPELES. ¡LISTO PARA DIFUNDIR!",
        expCopyError: "❌ ERROR AL COPIAR: Intenta compartir manualmente.",
        expControlArchive: "📑 CONTROL DE ARCHIVO: Los informes enviados serán validados por el Administrador antes de su publicación definitiva.",
        expViewRadar: "📍 VER EN RADAR",
        expOrigin: "ORIGEN",
        expMarkRelevant: "⭐ MARCAR COMO RELEVANTE",
        expDiffuse: "📡 DIFUNDIR EN EL RADAR EXTERNO (MUFON/UFO):",
        expPosicion: "📍 POSICIÓN",
        // Navbar / Footer Additional
        navProfile: "MI PERFIL",
        navLogout: "SALIR",
        navLogin: "ACCESO",
        footerAuthor: "Autor: José Moreno Jiménez.",
        footerRights: "Prohibida la reproducción no autorizada.",
        footerVisits: "VISITAS AL BÚNKER:",
        footerContact: "CONTACTO ALTO MANDO:",
        // LecturaHistoria
        readDecrypting: "DESENCRIPTANDO ARCHIVO SECRETO...",
        readNotFound: "⚠️ EL ARCHIVO NO EXISTE O HA SIDO ELIMINADO.",
        readBack: "VOLVER AL ARCHIVO",
        readViewRadar: "🎯 VER EN RADAR",
        readLocateRadar: "📍 LOCALIZAR EN RADAR",
        readDelete: "BORRAR",
        readNoTitle: "EXPEDIENTE SIN TÍTULO",
        readAdminStory: "RELATO DE COMANDANCIA",
        readAgentRegistry: "REGISTRO DE AGENTE EXTERNO",
        readSystemCentral: "SISTEMA CENTRAL",
        readNoContent: "CONTENIDO CLASIFICADO O NO DISPONIBLE.",
        readSource: "CONSULTAR FUENTE ORIGINAL DEL INFORME",
        readConfirmDeleteAdmin: "¿Sultán, seguro que desea destruir su propio relato para siempre?",
        readConfirmDeleteAgent: "¿Seguro que desea eliminar este expediente de usuario?",
        readDeleteSuccess: "✅ Expediente borrado de la existencia.",
        readDeleteError: "❌ Error: Las sombras impiden borrar este archivo.",
        // NoticiasExternas
        extLessHour: "Hace menos de 1 hora",
        extHours: "Hace {h}h",
        extYesterday: "Ayer",
        extScanning: "Escaneando frecuencias internacionales...",
        extRadarTitle: "RADAR DE INTELIGENCIA EXTERNA",
        extSignals: "señales",
        extReadSource: "LEER FUENTE",
        readTranslateStory: "TRADUCIR CONTENIDO (AI/GOOGLE)",
        readTranslateWait: "Sincronizando radar de traducción...",
        // Dossier Atarfe
        dossierAtarfeLoading: "📡 DESCLASIFICANDO ARCHIVO...",
        dossierAtarfeStamp: "TOP SECRET / DESCLASIFICADO",
        dossierAtarfeTitle: "INFORME TÉCNICO: INCIDENTE ATARFE",
        dossierAtarfeSubtitle: "INFORME TÉCNICO: INCIDENTE ATARFE (GRANADA, ESPAÑA)",
        dossierAtarfeAccessLabel: "NIVEL DE ACCESO:",
        dossierAtarfeAccessValue: "4 - ARCHIVERO CENTRAL",
        dossierAtarfeStatusLabel: "ESTADO:",
        dossierAtarfeStatusValue: "EN ANÁLISIS INTERNACIONAL (MUFON)",
        dossierAtarfeWarning: "⚠️",
        dossierAtarfeWarningBold: "AVISO:",
        dossierAtarfeWarningText: "El siguiente material contiene grabaciones originales sin editar. La calidad del audio y vídeo responde a las condiciones de campo en el momento del avistamiento.",
        dossierAtarfeChronicleTitle: "CRÓNICA DEL INCIDENTE: EL TESTIMONIO",
        dossierAtarfePhase1Label: "FASE 1: AGOSTO 2021 (SIERRA ELVIRA)",
        dossierAtarfePhase1Quote1: "\"Nos encontrábamos mi pareja y yo en la terraza de mi piso, era agosto del 2021. Estábamos tomando una copa de vino cuando observé una especie de avión que me llamó mucho la atención. Estamos acostumbrados a ver aviones por el aeropuerto cercano, pero este era muy raro. Al llegar a la altura de",
        dossierAtarfePhase1SierraElvira: "Sierra Elvira",
        dossierAtarfePhase1Quote1End: ", se paró en seco. Cambió de dirección, como si fuese marcha atrás, cambió de altura... Fui a por el móvil corriendo, un Huawei, y así grabé el primer vídeo donde se ve un solo objeto.\"",
        dossierAtarfePhase1Quote2: "\"Lo analicé en una televisión grande y me quedé alucinado: no se apagó, salió disparado dejando una estela. No había ningún sonido anormal.\"",
        dossierAtarfePhase2Label: "FASE 2: JUNIO 2022 (ALBOLOTE)",
        dossierAtarfePhase2Quote: "\"Me quedé obsesionado, lo mandé a Cuarto Milenio por WhatsApp y nadie me escuchó. Un año después, en junio de 2022, salí a la terraza a fumar y, como siempre desde el primer incidente, miré al cielo. Sobre la vertical de",
        dossierAtarfePhase2Albolote: "Albolote",
        dossierAtarfePhase2QuoteEnd: "aparecieron dos objetos similares al primero. Grabé todo lo que pude; se ven los tejados de los bloques de enfrente como referencia. De nuevo, silencio absoluto, solo el tráfico de la calle.\"",
        dossierAtarfePhase1Title: "FASE 1: EL ENCUENTRO INICIAL (AGOSTO 2021)",
        dossierAtarfePhase1Desc: "Registro de audio crítico. Debate sobre la naturaleza del objeto: \"Un dron, los cojones...\"",
        dossierAtarfePhase1EvidenceDesc: "Evidencia de objeto único con maniobras imposibles sobre Sierra Elvira.",
        dossierAtarfeCapturesTitle: "ANÁLISIS DE CAPTURAS (EXTRACCIONES DE VÍDEO)",
        dossierAtarfeCapturesDesc: "Capturas extraídas del análisis en pantalla de gran formato. Se observa la estela de propulsión.",
        dossierAtarfeEnlarge: "AMPLIAR EVIDENCIA / ENLARGE",
        dossierAtarfePhase2Title: "FASE 2: EL RETORNO (JUNIO 2022)",
        dossierAtarfePhase2Desc: "Avistamiento dual sobre la vertical de Albolote. Dos esferas en formación coordinada.",
        dossierAtarfePhase2EvidenceDesc: "Registro visual de dos objetos luminosos. Referencia visual: Tejado de bloques frontales.",
        dossierAtarfePurposeTitle: "EL PROPÓSITO DE ESTE ARCHIVO",
        dossierAtarfePurposeText: "\"A consecuencia de estos avistamientos, realicé un curso de confección y publicación de páginas web. El motivo principal de este Búnker es dar a conocer estos vídeos y capturas al mundo entero. Mi único objetivo es que, si algún experto llega a ver este material, pueda explicarme qué fue lo que vi esa noche. Solo entonces podré quedarme tranquilo.\"",
        dossierAtarfeSignature: "— El Investigador",
        dossierAtarfeSensorLabel: "SENSOR: UNIDAD ÓPTICA DE CAMPO",
        dossierAtarfeSectorLabel: "SECTOR: ATARFE (GRANADA)",
        dossierAtarfeCoordLabel: "COORDENADAS:",
        dossierAtarfeWatermarkTitle: "VIDEO ORIGINAL EXPEDIENTEXGRANAINO",
        dossierAtarfeWatermarkCopyright: "© INVESTIGACIÓN ATARFE - PROPIEDAD DEL BÚNKER",
        dossierAtarfeModalWatermark1: "ARCHIVO ORIGINAL: EXPEDIENTEXGRANAINO.COM",
        dossierAtarfeModalWatermark2: "INVESTIGACIÓN ATARFE - PROPIEDAD EXCLUSIVA",
        casesDisclaimerTitle: "⚠️ DIRECTIVA DE INVESTIGACIÓN DE CAMPO",
        casesDisclaimerText: "Los expedientes y misterios presentados en este búnker son fichas analíticas preliminares y resúmenes sintetizados (aproximadamente de unas 400 palabras). Dado que sobre muchos de estos sucesos se han escrito libros enteros y realizado décadas de investigación, instamos a todos los agentes y visitantes a utilizar este archivo como un punto de partida operativo. Le recomendamos encarecidamente contrastar datos, investigar a fondo por su cuenta y utilizar la caja de comentarios para aportar cualquier documento, testimonio o corrección que ayude a la comunidad."
    },
    en: {
        // General
        submit: "SEND SIGNAL",
        cancel: "ABORT",
        home: "HOME",
        loading: "PROCESSING...",
        back: "BACK",
        // SeccionUsuarios
        loginTitle: "AGENT IDENTIFICATION",
        registerTitle: "SYSTEM REGISTRATION",
        loginSubtitle: "Enter your access credentials",
        registerSubtitle: "Join the investigation network",
        namePlaceholder: "YOUR NAME OR ALIAS",
        cityPlaceholder: "CITY (OPTIONAL)",
        emailPlaceholder: "EMAIL ADDRESS",
        passwordPlaceholder: "PASSWORD",
        noAccount: "Don't have credentials yet? ",
        hasAccount: "Already an official agent? ",
        registerLink: "Register here",
        loginLink: "Log in",
        // Carta Astral
        astralTitle: "AGENT'S ASTRAL CHART",
        astralSubtitle: "Deciphering the coordinates of your destiny",
        birthDate: "Date of Birth",
        birthTime: "Time (If known)",
        birthCity: "City of Origin",
        cityExample: "Ex: London, UK",
        tuneButton: "TUNE CHART",
        // Tarot
        tarotTitle: "THE BUNKER ORACLE",
        tarotSubtitle: "Select 5 Arcanos to decipher your frequency",
        tarotCardsChosen: "Cards chosen",
        tarotReveal: "REVEAL DESTINY",
        tarotNewRitual: "NEW RITUAL",
        tarotMessage: "📜 MESSAGE FROM THE ORACLE",
        tarotSyncing: "TUNING...",
        // Horoscopo
        horoscopoTitle: "BUNKER HOROSCOPE",
        horoscopoSubtitle: "The stars reveal what the shadows hide",
        horoscopoLoading: "Tuning stellar frequencies...",
        horoscopoSyncDate: "Sync date",
        horoscopoWarning: "Warning: Predictions are generated by the IA frequency. Fate is in your hands.",
        horoscopoBack: "BACK TO THE BUNKER",
        // Navbar
        navHome: "HOME",
        navGallery: "GALLERY",
        navVideos: "VIDEOS",
        navNews: "NEWS",
        navAudios: "AUDIOS",
        navMysteries: "HISTORICAL MYSTERIES",
        navFiles: "DOSSIERS",
        navMap: "MAP",
        navHoroscope: "HOROSCOPE",
        navTarot: "TAROT",
        navAstral: "ASTRAL",
        navChat: "CHAT",
        // Home (Indice)
        systemActive: "SURVEILLANCE SYSTEM ACTIVE - GRANADA/GLOBAL SECTOR",
        systemStatusLabel: "SYSTEM STATUS:",
        systemStatusValue: "OPERATIONAL / ACTIVE SURVEILLANCE",
        sectorLabel: "SECTOR:",
        sectorValue: "GRANADA - GLOBAL",
        accessLevelLabel: "ACCESS LEVEL:",
        accessLevelAgent: "AUTHORIZED AGENT",
        accessLevelVisitor: "UNIDENTIFIED VISITOR",
        recentIntel: "RECENT INTEL:",
        tickerText: "🛰️ SATELLITE ONLINE: TRACKING SIGNALS IN GRANADA SECTOR... 🛸 ANOMALOUS ACTIVITY DETECTED IN ATARFE... 📡 CENTRAL ARCHIVE UPDATED... 🎖️ NEW RANKS AVAILABLE FOR ACTIVE AGENTS...",
        visualCalibration: "VISUAL CALIBRATION:",
        navPrivacy: "PRIVACY POLICY",
        navCookies: "COOKIES POLICY",
        navLegal: "LEGAL NOTICE",
        navAboutProject: "ABOUT THE PROJECT",
        dossierTitle: "JOSE MORENO JIMÉNEZ - INVESTIGATOR IN COMMAND",
        dossierDesc1: "Behind this bunker lies a true story. My curiosity for the unexplained was triggered after personally recording anomalous objects in Atarfe (Granada), an event that changed my way of seeing the sky and was the driving force behind founding this platform.",
        dossierDesc2: "EXPEDIENTEXGRANAINO was born from the need to centralize evidence and testimonies from all over the world to compare them and seek answers. Here we do not seek to impose truths, but to share questions and protect the hidden history of our planet.",
        dossierViewAtarfe: "📹 VIEW ATARFE RECORDING",
        dossierFullProtocols: "CONSULT FULL PROTOCOLS",
        rankSystemTitle: "RANK AND MERIT SYSTEM",
        rankSystemDesc: "Every report sent and every interaction in the bunker grants you experience points to rise in the sector's chain of command.",
        rankLevels: "🔰 Trainee ➔ 🎖️ Corporal (3) ➔ 🎖️🎖️ Corporal 1st (10) ➔ ⭐ Sergeant (20) ➔ ⭐⭐ Lieutenant (50) ➔ ⭐⭐⭐ Captain (100)",
        accessWorldRadar: "ACCESS WORLD RADAR (MAP)",
        reportExperience: "REPORT EXPERIENCE / EVENT",
        freeAgentRegister: "FREE AGENT REGISTRATION",
        contributeMedia: "CONTRIBUTE MULTIMEDIA EVIDENCE",
        dossierOpen: "[+] DECLASSIFY BUNKER ORIGIN (ABOUT ME)",
        dossierClose: "[-] CLOSE PERSONAL FILE",
        dossierBtnAtarfe: "📹 WATCH ATARFE RECORDING",
        dossierBtnProtocols: "CONSULT FULL PROTOCOLS",
        // Bilingual Slide
        slideBilingualTitle: "BILINGUAL VERSION ACTIVE",
        slideBilingualSubtitle: "INTERNATIONAL CONNECTION",
        slideBilingualTagline: "ESP/ENG FULL SUPPORT",
        slideBilingualInfoTitle: "MULTILANGUAGE BUNKER",
        slideBilingualInfoText: "We have declassified our interface for international agents. You can now navigate the entire bunker in Spanish and English.",
        slideBilingualHighlight: "CONNECT WITH THE GLOBAL NETWORK!",
        slideBilingualBtn: "SWITCH LANGUAGE",
        // Efemerides
        efemeridesTitle: "TODAY IN X-HISTORY",
        efemeridesLoading: "Declassifying historical files...",
        efemeridesExpand: "[+] DECLASSIFY FULL REPORT",
        efemeridesCollapse: "[-] CLASSIFY ARCHIVE",
        efemeridesFooter: "DECLASSIFIED ARCHIVE — EXPEDIENTEXGRANAINO",
        // About Us
        aboutTitle: "📂 PROJECT DOSSIER",
        aboutWhatIs: "WHAT IS EXPEDIENTEX GRANAINO?",
        aboutWhatIsDesc1: "Expediente X Granaino is an independent digital project created in 2026 in Atarfe (Granada, Spain) by José Moreno Jiménez. It was born with a clear goal: to serve as a documentary index and synthesis repository of real events, anomalous phenomena, true crime, and historical mysteries from Spain and around the world.",
        aboutWhatIsDesc2: "This archive does not claim to be an overwhelming encyclopedia of endless 20,000-word academic treatises, but rather an accessible, direct, and rigorous guide. Each dossier is conceived as a synthesis briefing designed to spark the reader's curiosity, present documented evidence, and serve as a launchpad to encourage further personal investigation through verified sources and specialized literature.",
        aboutOrigin: "THE ORIGIN OF THE BUNKER",
        aboutOriginDesc1: "Behind the coding and maintenance of this website there is no massive editorial team or corporation: I am José Moreno Jiménez, an independent programmer and mystery enthusiast from Atarfe. My passion for these phenomena deepened after personally witnessing and filming unidentified aerial phenomena for which I found no conventional explanation (you can watch the original recording in our video section).",
        aboutOriginDesc2: "That personal experience was the catalyst that led me in 2026 to develop this website. Far from inventing fiction or imposing absolute truths, this bunker aims to organize real cases that often remain forgotten in historical archives, share legitimate questions, and provide books and sources so each reader can draw their own conclusions.",
        aboutMethodology: "METHODOLOGY & ARCHIVE PHILOSOPHY",
        aboutMethodologyDesc1: "The methodology of this portal is based on informative synthesis of public archives, declassified documents, historic press reports, and direct testimonies. My work consists of filtering, compiling, and summarizing the cardinal points of each event so the reader gets a clear overview in just a few minutes of reading.",
        aboutMethodologyDesc2: "At the end of dossiers where reference works have been published by historians, journalists, or witnesses, we include a recommended bibliography section. This way, anyone wishing to transition from initial curiosity to deep investigation has key books and essays at their fingertips.",
        aboutMission: "PURPOSE",
        aboutMissionDesc: "Provide a clear and concise index of real cases to spark critical curiosity.",
        aboutVision: "PHILOSOPHY",
        aboutVisionDesc: "Transparency, independent research, and respect for documented sources.",
        aboutValues: "VALUES",
        aboutValuesDesc: "Honesty, historical truth, and genuine passion for real mysteries.",
        aboutContact: "DO YOU KNOW A REAL CASE OR HAVE INFORMATION? CONTACT ME OR FOLLOW ON SOCIAL MEDIA:",
        // Expedientes
        expTitle: "DOSSIERS & CLASSIFIED CASES",
        expProtocol: "🛡️ VERACITY PROTOCOL: We prioritize reports based on real events, direct testimonies, and field evidence. Although we allow narrative reconstruction, fidelity to facts is our standard. Document responsibly.",
        expAgentReports: "AGENT REPORTS",
        expAdminStories: "ADMINISTRATOR STORIES",
        expStatus: "STATUS",
        expImage: "IMAGE",
        expLocation: "LOCATION",
        expAction: "ACTION",
        expOpen: "OPEN",
        expRadarSearch: "GEOGRAPHIC RADAR (SEARCH CITY/TOWN):",
        expWriteReport: "WRITE NEW REPORT",
        expWriteAdmin: "WRITE OFFICIAL STORY",
        expPublish: "PUBLISH STORY",
        expUpload: "UPLOAD TO ARCHIVE",
        expDecrypt: "DECRYPTING SIGNAL...",
        expNoData: "📡 CLEAN FREQUENCY. NO ACTIVITY DETECTED.",
        expSearchPlaceholder: "Search by title, content or agent alias...",
        expFilterAll: "📁 VIEW ALL",
        expFilterAdmin: "🛡️ HIGH COMMAND",
        expFilterAgent: "👤 FIELD AGENTS",
        // App / System
        sysLogoutConfirm: "FINISH GUARD SHIFT, AGENT?",
        sysLogoutBtn: "DISCONNECT AGENT",
        sysAccessBunker: "🔑 BUNKER ACCESS",
        sysAgentLabel: "👤 AGENT:",
        sysControlPanel: "⚡ CONTROL PANEL",
        sysVisualFreq: "VISUAL FREQUENCY",
        sysSidebarDossier: "⚠️ Atarfe Dossier",
        sysSidebarDossierDesc: "Atarfe Dossier",
        // Galeria
        galleryTitle: "EVIDENCE GALLERY",
        galleryAccessLevel: "ACCESS LEVEL:",
        galleryWriteStory: "WRITE STORY",
        galleryTabNews: "NEWS",
        galleryTabStories: "STORIES",
        galleryTabMisterios: "MYSTERIES",
        galleryTabTrueCrime: "TRUE CRIME",
        galleryNoData: "📡 SCANNING SECTOR... NO RECORDS DETECTED.",
        galleryScanning: "SCANNING SECTOR...",
        galleryViewFullStory: "📖 READ FULL STORY",
        galleryViewFullNews: "📰 VIEW FULL NEWS",
        galleryViewFullMisterio: "👽 VIEW FULL MYSTERY",
        galleryViewFullCaso: "💀 VIEW FULL CASE",
        galleryRadarLocalize: "📍 LOCATE ON RADAR",
        galleryLinkedFile: "🔒 LINKED FILE: This graphic evidence is part of a detailed chronicle in the central archive. Press the button above to declassify the full story.",
        galleryNoNotes: "No additional notes in the report.",
        badgeNews: "📰 NEWS",
        badgeMystery: "👽 HISTORICAL MYSTERY",
        badgeTrueCrime: "🛡️ TRUE CRIME / CASE",
        badgeAgentExp: "👤 AGENT FILE",
        // Chat
        chatFrequency: "FREQUENCY:",
        chatOnline: "(ONLINE)",
        chatOffline: "(OFFLINE)",
        chatReset: "RESET",
        chatSearching: "📡 Searching for signals on the frequency...",
        chatWriteOrder: "Write order...",
        chatWriteMessage: "Write message...",
        chatEmit: "EMIT",
        chatTransmit: "TRANSMIT",
        // Astral Chart Months
        month1: "January",
        month2: "February",
        month3: "March",
        month4: "April",
        month5: "May",
        month6: "June",
        month7: "July",
        month8: "August",
        month9: "September",
        month10: "October",
        month11: "November",
        month12: "December",
        day: "Day",
        month: "Month",
        year: "Year",
        // Evidence & Reporting
        reportEvidence: "REPORT EVIDENCE",
        findingTitle: "FINDING TITLE",
        findingPlaceholder: "Ex: EVP in basement...",
        imageUrlOptional: "IMAGE URL (OPTIONAL)",
        latLong: "LATITUDE / LONGITUDE",
        scanGps: "🛰️ SCAN SECTOR (GPS)",
        uploadMethod: "UPLOAD METHOD",
        uploadFile: "UPLOAD FILE (.MP3)",
        uploadLink: "LINK / IFRAME (iVoox, Spotify)",
        fileMp3: "FILE (.MP3)",
        externalLink: "INSERTION CODE OR LINK",
        externalLinkPlaceholder: "Paste here the <iframe...> code or external link",
        // News
        newsTitle: "EVENT HEADLINE",
        newsLocation: "📍 LOCATION (GPS SEARCH):",
        newsLocationPlaceholder: "Ex: NASA, Area 51, Granada...",
        newsSearch: "SEARCH",
        newsSource: "🌐 SOURCE LINK (OPTIONAL):",
        newsVisual: "📷 ATTACH VISUAL EVIDENCE:",
        newsLevel: "ALERT LEVEL:",
        newsLevelLow: "Low",
        newsLevelMed: "Medium",
        newsLevelHigh: "High",
        newsLevelCrit: "CRITICAL",
        newsDesc: "DESCRIBE THE DETAILS OF THE SIGHTING OR EVENT...",
        // Videos
        videoRegister: "RECORD NAME:",
        videoRegisterPlaceholder: "Ex: Sighting in the Genil",
        videoUrl: "URL OR FILE NAME:",
        videoUrlPlaceholder: "YouTube URL or local file name",
        videoCaptures: "CAPTURE URLS (Separated by commas):",
        videoCapturesPlaceholder: "https://image1.jpg, https://image2.jpg...",
        videoGps: "🛰️ ACTIVATE GPS RADAR (CURRENT LOCATION)",
        // Messages
        accessDenied: "⚠️ RESTRICTED ACCESS",
        loginRequired: "You must be identified in the bunker to access your astral frequency.",
        errorFallen: "Bunker server failure.",
        successAuth: "✅ ACCESS CONFIRMED",
        successReg: "✅ READY! You have joined the Bunker network.",
        anonymousInfo: "🔒 100% ANONYMOUS: We only need your Alias and Password.",
        optionalEmail: "Only if you want to recover password later...",
        yourSector: "Your sector...",
        // Map (Lugares)
        mapExpand: "VIEW IN SECTION",
        mapLoading: "SCANNING SECTOR...",
        mapError: "LOAD ERROR",
        mapDossier: "📜 DOSSIER",
        mapNews: "📰 NEWS",
        mapPlace: "📍 PLACE",
        mapEvidence: "📸 EVIDENCE",
        mapAuthor: "AUTHOR",
        mapAgent: "AGENT",
        mapSystem: "SYSTEM",
        mapNoDesc: "No additional description in the file.",
        mapObjectives: "OBJECTIVES",
        mapSystemLabel: "SYSTEM",
        mapActive: "ACTIVE",
        // Videos & Audios Alerts
        videoNoGps: "The bunker does not detect your GPS signal.",
        videoGpsError: "❌ SCAN SECTOR FAILURE: ",
        videoIdentify: "Identify yourself as an agent.",
        videoSent: "✅ VIDEO SENT: Central will review the material before publishing.",
        audioNoGps: "GPS NOT DETECTED.",
        audioNoFile: "Select a file first, brother.",
        audioNoLink: "Paste a link or iframe code.",
        audioSent: "✅ EVP sent. High Command must review it.",
        audioError: "❌ Transmission failure. Verify your agent identity.",
        audioExternal: "🎧 OPEN EXTERNAL FILE",
        audioNoData: "📡 No approved records or database is offline...",
        audioCompatible: "SYSTEM NOT COMPATIBLE",
        // Hero Slides
        heroReport: "Report Sighting",
        heroGalleryTitle: "MULTIMEDIA & EVIDENCE",
        heroGalleryDesc: "Explore our gallery of photos and videos analyzed by central command. Evidence of the inexplicable in high resolution.",
        heroGalleryBtn: "Explore Gallery",
        heroStoriesTitle: "STORIES & MYSTERIES",
        heroStoriesDesc: "Immerse yourself in the most shocking stories and historical mysteries that defy logic. The truth is written in these pages.",
        heroStoriesBtn: "Read Stories",
        heroRankTitle: "AGENT RANK SYSTEM",
        heroRankDesc: "Your loyalty and activity are monitored. Rise automatically: Agent > Corporal > Sergeant > Lieutenant > Captain. Reach elite status!",
        heroRankBtn: "View My Profile",
        heroRegisterTitle: "100% ANONYMOUS REGISTRATION",
        heroRegisterDesc: "We have updated our security protocols. You can now register using only an Alias. Zero personal data.",
        heroRegisterBtn: "Register Now",
        heroNewFile: "NEW FILE",
        heroLatestNews: "LATEST NEWS",
        heroLatestExp: "BREAKING NEWS",
        heroNewsBtn: "Read News",
        heroExpBtn: "Open Report",
        heroNavReport: "REPORT EXPERIENCE",
        heroNavReg: "FREE REGISTRATION",
        heroNavMedia: "CONTRIBUTE MEDIA",
        heroNavAccess: "AGENT ACCESS",
        heroObserverNetwork: "OBSERVER NETWORK",
        heroObserverTitle: "EXPEDIENTEXGRANAINO OBSERVER NETWORK",
        heroObserverText: "Be part of the next big event. An exclusive network for UFO and technical ufology enthusiasts.",
        heroObserverHighlight: "ONLY FOR BUNKER MEMBERS!",
        // Noticias
        newsSystemScanning: "TUNING NEWS ARCHIVE...",
        newsGlobalAlerts: "NEWS & CURRENT CHRONICLES",
        newsNoImage: "ARCHIVE WITHOUT IMAGE",
        newsNoAlerts: "NO ACTIVE LOCAL ALERTS. SCANNING SECONDARY FREQUENCIES...",
        newsExternalIntel: "🌐 EXTERNAL INTELLIGENCE (RECOMMENDED CHANNELS)",
        newsAccess: "ACCESS",
        newsPrev: "BACK",
        newsNext: "NEXT",
        newsReportSent: "📡 REPORT SENT TO THE BUNKER. WAIT FOR HIGH COMMAND VALIDATION.",
        newsError: "❌ Transmission interrupted. Check your connection.",
        // Expedientes Addons
        expShareText: "🛸 SIGHTING DETECTED! Check this dossier in the ExpedienteX Bunker: ",
        expCopySuccess: "📎 LINK COPIED TO CLIPBOARD. READY TO BROADCAST!",
        expCopyError: "❌ COPY ERROR: Try sharing manually.",
        expControlArchive: "📑 ARCHIVE CONTROL: Reports sent will be validated by the Administrator before final publication.",
        expViewRadar: "📍 VIEW ON RADAR",
        expOrigin: "ORIGIN",
        expMarkRelevant: "⭐ MARK AS RELEVANT",
        expDiffuse: "📡 DIFFUSE ON EXTERNAL RADAR (MUFON/UFO):",
        expPosicion: "📍 POSITION",
        // Navbar / Footer Additional
        navProfile: "MY PROFILE",
        navLogout: "EXIT",
        navLogin: "LOGIN",
        footerAuthor: "Author: José Moreno Jiménez.",
        footerRights: "Unauthorized reproduction prohibited.",
        footerVisits: "BUNKER VISITS:",
        footerContact: "HIGH COMMAND CONTACT:",
        // LecturaHistoria
        readDecrypting: "DECRYPTING SECRET FILE...",
        readNotFound: "⚠️ THE FILE DOES NOT EXIST OR HAS BEEN DELETED.",
        readBack: "BACK TO ARCHIVE",
        readViewRadar: "🎯 VIEW ON RADAR",
        readLocateRadar: "📍 LOCATE ON RADAR",
        readDelete: "DELETE",
        readNoTitle: "EXPEDIENT WITHOUT TITLE",
        readAdminStory: "COMMAND STORY",
        readAgentRegistry: "EXTERNAL AGENT REGISTRY",
        readSystemCentral: "CENTRAL SYSTEM",
        readNoContent: "CLASSIFIED CONTENT OR NOT AVAILABLE.",
        readSource: "CONSULT ORIGINAL REPORT SOURCE",
        readConfirmDeleteAdmin: "Sultan, are you sure you want to destroy your own story forever?",
        readConfirmDeleteAgent: "Are you sure you want to delete this user dossier?",
        readDeleteSuccess: "✅ Dossier deleted from existence.",
        readDeleteError: "❌ Error: Shadows prevent deleting this file.",
        // NoticiasExternas
        extLessHour: "Less than 1 hour ago",
        extHours: "{h}h ago",
        extYesterday: "Yesterday",
        extScanning: "Scanning international frequencies...",
        extRadarTitle: "EXTERNAL INTELLIGENCE RADAR",
        extSignals: "signals",
        extReadSource: "READ SOURCE",
        readTranslateStory: "TRANSLATE CONTENT (AI/GOOGLE)",
        readTranslateWait: "Syncing translation radar...",
        // Dossier Atarfe
        dossierAtarfeLoading: "📡 DECLASSIFYING FILE...",
        dossierAtarfeStamp: "TOP SECRET / DECLASSIFIED",
        dossierAtarfeTitle: "TECHNICAL REPORT: ATARFE INCIDENT",
        dossierAtarfeSubtitle: "TECHNICAL REPORT: ATARFE INCIDENT (GRANADA, SPAIN)",
        dossierAtarfeAccessLabel: "ACCESS LEVEL:",
        dossierAtarfeAccessValue: "4 - CENTRAL ARCHIVIST",
        dossierAtarfeStatusLabel: "STATUS:",
        dossierAtarfeStatusValue: "UNDER INTERNATIONAL ANALYSIS (MUFON)",
        dossierAtarfeWarning: "⚠️",
        dossierAtarfeWarningBold: "WARNING:",
        dossierAtarfeWarningText: "The following material contains original unedited recordings. Audio and video quality reflects field conditions at the time of the sighting.",
        dossierAtarfeChronicleTitle: "INCIDENT CHRONICLE: THE TESTIMONY",
        dossierAtarfePhase1Label: "PHASE 1: AUGUST 2021 (SIERRA ELVIRA)",
        dossierAtarfePhase1Quote1: "\"My partner and I were on the terrace of my apartment, it was August 2021. We were having a glass of wine when I spotted what looked like a plane that caught my attention. We are used to seeing planes near the airport, but this one was very strange. When it reached the height of",
        dossierAtarfePhase1SierraElvira: "Sierra Elvira",
        dossierAtarfePhase1Quote1End: ", it stopped dead. It changed direction, as if reversing, changed altitude... I ran inside to get my phone, a Huawei, and that's how I recorded the first video showing a single object.\"",
        dossierAtarfePhase1Quote2: "\"I analysed it on a large TV screen and was astonished: it didn't turn off — it shot away leaving a trail. There was no unusual sound whatsoever.\"",
        dossierAtarfePhase2Label: "PHASE 2: JUNE 2022 (ALBOLOTE)",
        dossierAtarfePhase2Quote: "\"I became obsessed, I sent it to Cuarto Milenio via WhatsApp and nobody listened. A year later, in June 2022, I went out on the terrace for a smoke and, as always since the first incident, I looked up at the sky. Above",
        dossierAtarfePhase2Albolote: "Albolote",
        dossierAtarfePhase2QuoteEnd: "two objects similar to the first one appeared. I recorded everything I could; you can see the rooftops of the buildings across the street as a reference. Again, absolute silence — only the traffic noise from the street.\"",
        dossierAtarfePhase1Title: "PHASE 1: INITIAL ENCOUNTER (AUGUST 2021)",
        dossierAtarfePhase1Desc: "Critical audio recording. Debate about the nature of the object.",
        dossierAtarfePhase1EvidenceDesc: "Evidence of a single object with impossible manoeuvres over Sierra Elvira.",
        dossierAtarfeCapturesTitle: "CAPTURE ANALYSIS (VIDEO FRAME EXTRACTIONS)",
        dossierAtarfeCapturesDesc: "Frames extracted from large-format screen analysis. The propulsion trail is clearly visible.",
        dossierAtarfeEnlarge: "AMPLIAR EVIDENCIA / ENLARGE",
        dossierAtarfePhase2Title: "PHASE 2: THE RETURN (JUNE 2022)",
        dossierAtarfePhase2Desc: "Dual sighting above Albolote. Two spheres in coordinated formation.",
        dossierAtarfePhase2EvidenceDesc: "Visual record of two luminous objects. Visual reference: Rooftops of adjacent blocks.",
        dossierAtarfePurposeTitle: "THE PURPOSE OF THIS ARCHIVE",
        dossierAtarfePurposeText: "\"As a result of these sightings, I took a course in creating and publishing websites. The main purpose of this Bunker is to bring these videos and images to the whole world. My only objective is that if any expert ever sees this material, they can explain to me what I witnessed that night. Only then will I be able to find peace.\"",
        dossierAtarfeSignature: "— The Investigator",
        dossierAtarfeSensorLabel: "SENSOR: OPTICAL FIELD UNIT",
        dossierAtarfeSectorLabel: "SECTOR: ATARFE (GRANADA)",
        dossierAtarfeCoordLabel: "COORDINATES:",
        dossierAtarfeWatermarkTitle: "ORIGINAL VIDEO EXPEDIENTEXGRANAINO",
        dossierAtarfeWatermarkCopyright: "© ATARFE INVESTIGATION - BUNKER PROPERTY",
        dossierAtarfeModalWatermark1: "ORIGINAL FILE: EXPEDIENTEXGRANAINO.COM",
        dossierAtarfeModalWatermark2: "ATARFE INVESTIGATION - EXCLUSIVE PROPERTY",
        casesDisclaimerTitle: "⚠️ FIELD INVESTIGATION DIRECTIVE",
        casesDisclaimerText: "The dossiers and mysteries compiled in this bunker are preliminary analytical briefs and synthesized summaries (approximately 400 words). Since many of these events have inspired entire books and decades of research, we urge all agents and visitors to use this archive as an operational starting point. We strongly recommend cross-referencing facts, conducting your own deep research, and using the comment section to contribute any documents, testimonies, or corrections to help the community."
    }
};

export const LanguageProvider = ({ children }) => {
    const getInitialLanguage = () => {
        try {
            if (typeof window !== 'undefined' && window.location) {
                const params = new URLSearchParams(window.location.search);
                const urlLang = params.get('lang');
                if (urlLang === 'es' || urlLang === 'en') {
                    safeLocalStorage.setItem('bunker_lang', urlLang);
                    return urlLang;
                }
            }
        } catch (e) {}
        return safeLocalStorage.getItem('bunker_lang') || 'es';
    };

    const [language, setLanguage] = useState(getInitialLanguage);

    useEffect(() => {
        safeLocalStorage.setItem('bunker_lang', language);
        
        // Sincronización automática continua con el combo de Google Translate
        const syncGoogleTranslate = () => {
            try {
                const googleCombo = document.querySelector('.goog-te-combo');
                if (googleCombo && googleCombo.value !== language) {
                    googleCombo.value = language;
                    googleCombo.dispatchEvent(new Event('change'));
                }
            } catch (e) {
                // Silencioso
            }
        };

        syncGoogleTranslate();
        const interval = setInterval(syncGoogleTranslate, 2000);
        return () => clearInterval(interval);
    }, [language]);

    const t = (key) => {
        return translations[language][key] || key;
    };

    const toggleLanguage = () => {
        const nextLang = language === 'es' ? 'en' : 'es';
        setLanguage(nextLang);
        safeLocalStorage.setItem('bunker_lang', nextLang);

        // --- SINCRONIZACIÓN TÁCTICA CON GOOGLE TRANSLATE ---
        // Intentamos forzar al widget de Google a traducir si está presente
        try {
            const googleCombo = document.querySelector('.goog-te-combo');
            if (googleCombo) {
                googleCombo.value = nextLang;
                googleCombo.dispatchEvent(new Event('change'));
            }
        } catch (e) {
            console.log("Radar de traducción externa no disponible.");
        }
    };

    const forceTranslationUpdate = useCallback(() => {
        if (language !== 'es') {
            setTimeout(() => {
                try {
                    const googleCombo = document.querySelector('.goog-te-combo');
                    if (googleCombo) {
                        googleCombo.value = 'es';
                        googleCombo.dispatchEvent(new Event('change'));
                        setTimeout(() => {
                            googleCombo.value = language;
                            googleCombo.dispatchEvent(new Event('change'));
                        }, 300);
                    }
                } catch (e) {}
            }, 500);
        }
    }, [language]);

    return (
        <LanguageContext.Provider value={{ language, setLanguage, t, toggleLanguage, forceTranslationUpdate }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);
